module.exports = "/location-inactive-warning-007df52e38c3478e7fc83445fe0d6bff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/CreateRoute/LocationMarkerGroup/LocationMarker/icons/location-inactive-warning.svg
// module id = WDbj
// module chunks = 4